import React, { forwardRef, useRef, useEffect, useState } from 'react';
import { CloseOutlined } from '@teko/ds-icon';
import { YoutubeThumbnail, styled, Flex, Glide, Shape, LazyImage } from '@teko/ds-desktop';
import { SOURCE_VIDEO } from '../../constants/index.es.js';
import { ProductVideo } from '../ProductVideo/ProductVideo.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const GalaryFooter = forwardRef(({ indexActive, setIndexActive, onSlideChange, images, videos = [] }, ref) => {
  const wrapper = useRef(null);
  const vidRef = useRef(null);
  const changeSlide = (index) => {
    setIndexActive(index);
    if (typeof ref !== "function" && (ref == null ? void 0 : ref.current) && wrapper.current) {
      const itemPercents = (index + 0.5) / images.length;
      const itemsRect = ref.current.getBoundingClientRect();
      const wrapperRect = wrapper.current.getBoundingClientRect();
      const widthTransform = itemPercents * wrapperRect.width - itemsRect.width / 2;
      wrapper.current.style.transform = `translateX(-${widthTransform}px)`;
    }
  };
  useEffect(() => {
    if (typeof ref !== "function" && (ref == null ? void 0 : ref.current)) {
      ref.current.go = changeSlide;
    }
  }, []);
  return /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(Items, {
    ref
  }, /* @__PURE__ */ React.createElement(ItemsWrapper, {
    ref: wrapper
  }, [...videos, ...images].map((media, index) => /* @__PURE__ */ React.createElement(FooterItem, {
    key: index,
    className: index === indexActive ? "active" : ""
  }, index < videos.length ? media.source === SOURCE_VIDEO.SYSTEM ? /* @__PURE__ */ React.createElement(ThumbnailVideo, {
    url: media.src,
    source: media.source,
    videoProps: {
      ref: vidRef,
      width: 60,
      height: 60,
      preload: "none",
      playsInline: true,
      autoPlay: true,
      muted: true,
      onClick: () => onSlideChange(index),
      onPlayingCapture: () => {
        var _a;
        return (_a = vidRef.current) == null ? void 0 : _a.pause();
      }
    }
  }) : /* @__PURE__ */ React.createElement(YoutubeThumbnail, {
    key: index,
    width: 60,
    height: 60,
    youtubeLink: media.src,
    onClick: () => onSlideChange(index)
  }) : /* @__PURE__ */ React.createElement(Thumbnail, __spreadProps(__spreadValues({}, media), {
    contain: true,
    width: 60,
    height: 60,
    imageWidth: 150,
    borderRadius: 4,
    onClick: () => onSlideChange(index)
  })))))));
});
GalaryFooter.displayName = "GalaryFooter";
const ItemsWrapper = styled.div`
  display: flex;
  gap: 0.75rem;
  transition: all 0.3s ease-in;
`;
const GalleryIndex = styled.div`
  position: absolute;
  right: 10px;
  top: 20px;

  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Gallery = ({
  images,
  videos = [],
  onClose,
  bgColor,
  indexVisible,
  footerVisible = true,
  frame,
  activeImageIndex
}) => {
  const [indexActive, setIndexActive] = useState(activeImageIndex || 0);
  const footerController = useRef(null);
  const carouselController = useRef(null);
  const onSlideChange = (type, index) => {
    var _a, _b, _c;
    if (type == "carousel") {
      (_a = footerController.current) == null ? void 0 : _a.go(index);
    } else {
      (_c = (_b = carouselController.current) == null ? void 0 : _b.glide) == null ? void 0 : _c.go(`=${index}`);
    }
  };
  const listOfMedia = [...videos, ...images];
  return /* @__PURE__ */ React.createElement(Wrapper, {
    backgroundColor: bgColor
  }, /* @__PURE__ */ React.createElement(Flex, {
    style: { position: "absolute", width: "100%", zIndex: 10 },
    justify: indexVisible ? "space-between" : "end",
    padding: ["s12", "s16"]
  }, onClose && /* @__PURE__ */ React.createElement(ButtonClose, {
    onClick: onClose
  }, /* @__PURE__ */ React.createElement(CloseOutlined, {
    size: 30,
    color: "textSecondary"
  })), indexVisible && /* @__PURE__ */ React.createElement(GalleryIndex, null, indexActive + 1, " / ", listOfMedia.length)), /* @__PURE__ */ React.createElement(StyledContainer, null, /* @__PURE__ */ React.createElement(Glide, {
    type: "slider",
    perView: 1,
    autoplay: false,
    ref: carouselController,
    onSlideChange: (index) => onSlideChange("carousel", index),
    startAt: indexActive
  }, listOfMedia.map((media, index) => {
    return /* @__PURE__ */ React.createElement(GlideItem, {
      key: index,
      height: "100%",
      frame
    }, /* @__PURE__ */ React.createElement(ImageWrapper, null, index < videos.length ? /* @__PURE__ */ React.createElement(ProductVideo, {
      url: media.src,
      source: media.source,
      videoProps: {
        width: "100%",
        height: "100%",
        controls: true,
        preload: "none",
        autoPlay: true,
        playsInline: true,
        muted: true
      },
      youtubeFrameProps: {
        width: "100%",
        height: 400,
        autoplay: 1
      }
    }) : /* @__PURE__ */ React.createElement(StyledImage, __spreadProps(__spreadValues({
      contain: true
    }, media), {
      imageWidth: 1e3
    }))));
  }))), footerVisible && !!listOfMedia.length && /* @__PURE__ */ React.createElement(GalaryFooter, {
    indexActive,
    setIndexActive,
    images,
    ref: footerController,
    onSlideChange: (index) => onSlideChange("footer", index),
    videos
  }));
};
const GlideItem = styled(Flex)`
  background-image: ${({ frame }) => `url(${frame})`};
  background-size: cover;
`;
const Wrapper = styled(Shape)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  .glide__slide {
    height: 100%;
  }
`;
const Footer = styled.div`
  margin: 1rem auto;
  padding: 0 1.5rem;
  width: 800px;
  max-width: 100%;
  z-index: 3;
  text-align: left;

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }
`;
const StyledImage = styled(LazyImage)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
  }
`;
const FooterItem = styled.div`
  opacity: 0.4;

  &.active {
    opacity: 1;
  }
  img {
    user-select: none;
    -webkit-user-drag: none;
  }
`;
const Items = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Thumbnail = styled(LazyImage)`
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ThumbnailVideo = styled(ProductVideo)`
  cursor: pointer;
  transition: 0.1s ease opacity;
  &:hover {
    opacity: 0.6;
  }
`;
const ImageWrapper = styled.div`
  background: transparent;
  width: 700px;
  max-height: 100%;
  max-width: 100%;
  position: relative;
  margin: auto;
`;
const StyledContainer = styled.div`
  height: 100%;
  z-index: 4;
  width: 100%;
  > div {
    height: 100%;
    width: 100%;
  }
`;
const ButtonClose = styled.div(({ theme }) => `
  cursor: pointer;
  padding: 4px;
  &:hover {
    path{
      fill: ${theme == null ? void 0 : theme.colors.primary500} !important;
    }
  }
`);

export { Gallery };
